import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {listItemStyles} from '../../lists/list-item'
import {drawerListItemGraphicPrimary2Styles, drawerListItemGraphicStyles} from '../drawer-list-item-graphic'
import {listItemMetaPrimary2Styles} from '../drawer-list-item-meta'
import {SimpleListItem as RmwcSimpleListItem} from '@rmwc/list'
import '@rmwc/list/styles'

const StyledRmwcSimpleListItem = styled(RmwcSimpleListItem)`
  ${listItemStyles}
  &&& .mdc-list-item__graphic {
    ${drawerListItemGraphicStyles}
  }
  .mdc-theme--on-primary2 &&& .mdc-list-item__graphic {
    ${drawerListItemGraphicPrimary2Styles}
  }
  .mdc-theme--on-primary2 &&& .mdc-list-item__meta {
    ${listItemMetaPrimary2Styles}
  }
`

const DrawerSimpleListItem = ({children, ...otherProps}) => <StyledRmwcSimpleListItem {...otherProps}>{children}</StyledRmwcSimpleListItem>

DrawerSimpleListItem.propTypes = {
  children: PropTypes.any
}

export {DrawerSimpleListItem}
